import React from 'react';
import { Stack, TextField as MuiTextField } from '@mui/material';
import { ErrorMessage as ErrorMessageContainer } from '@hookform/error-message';
import { ErrorMessage } from '../Enquiry';
import InputLabel from '../InputLabel';

function TextField({
  containerSx,
  name,
  inputProps,
  errors,
  label,
  textFieldProps = {},
}) {
  return (
    <Stack direction='column' spacing={1.5} sx={containerSx}>
      {label && <InputLabel label={label} name={name} />}
      <MuiTextField
        size='small'
        variant='outlined'
        sx={{
          '& .MuiInputBase-root': {
            fontSize: 14,
            color: '#000',
            background: '#fff',
            mb: 0.5,
          },
          '& .MuiInputBase-input': {
            color: '#000',
            padding: '7px 10px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: 1,
            top: -10,
            borderColor: '#7E8CAB',
            borderWidth: '0.5px',
          },
        }}
        InputProps={inputProps}
        {...textFieldProps}
      />
        {errors && <ErrorMessageContainer errors={errors} name={name} as={ErrorMessage} />}
    </Stack>
  );
}

export default TextField;
